import { useEffect, useRef, useState } from "react";

export default function ScrollBarAdditional({
	className,
	classToSync,
	height = 10,
	style = {},
}: {
	className?: string;
	classToSync: string;
	height?: number;
	style?: React.CSSProperties;
}) {
	const scrollbarRef = useRef<HTMLDivElement>(null);
	const [size, _setSize] = useState({ contentWidth: 0, scrollbarWidth: 0 });

	function setSize() {
		const element = document.querySelector<HTMLDivElement>(`.${classToSync}`);
		_setSize({
			contentWidth: element?.scrollWidth || 0,
			scrollbarWidth: element?.getBoundingClientRect().width || 0,
		});
	}

	useEffect(() => {
		const element = document.querySelector<HTMLDivElement>(`.${classToSync}`);
		if (!element) return;

		const observer = new ResizeObserver(setSize);
		observer.observe(element);

		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		const scrollbar = scrollbarRef.current;
		const target = document.querySelector<HTMLDivElement>(`.${classToSync}`);
		if (!scrollbar || !target) return;

		const handleScrollbarScroll = () => {
			const ratio = target.scrollWidth / scrollbar.scrollWidth;
			target.scrollLeft = scrollbar.scrollLeft * ratio;
		};

		const handleTargetScroll = () => {
			const ratio = scrollbar.scrollWidth / target.scrollWidth;
			scrollbar.scrollLeft = target.scrollLeft * ratio;
		};

		scrollbar.addEventListener("scroll", handleScrollbarScroll);
		target.addEventListener("scroll", handleTargetScroll);

		return () => {
			scrollbar.removeEventListener("scroll", handleScrollbarScroll);
			target.removeEventListener("scroll", handleTargetScroll);
		};
	}, [classToSync]);

	return (
		<div
			ref={scrollbarRef}
			className={className}
			style={{
				width: size.scrollbarWidth,
				height,
				overflowX: "auto",
				backgroundColor: "bg-background",
				...style,
			}}
		>
			<div style={{ width: size.contentWidth, height: "100%" }} />
		</div>
	);
}
